import * as S from "./styles";

interface ProgressBarProps {
  progress?: number;
  variant?: "level";
}

export default function ProgressBar({ progress = 0, variant }: ProgressBarProps) {
  return (
    <S.Wrapper variant={variant}>
      <S.ProgressBar variant={variant} style={{ width: `${progress}%` }} />
    </S.Wrapper>
  );
}
